// src/redux/stockData/edgar/edgarSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchEdgarFilingsData } from "./edgarActions";

const edgarSlice = createSlice({
  name: "edgar",
  initialState: {
    companyInfo: null,
    filings: [],
    loading: false,
    error: null,
    lastFetchedTicker: null,
  },
  reducers: {
    clearEdgarData(state) {
      state.companyInfo = null;
      state.filings = [];
      state.error = null;
      state.loading = false;
      state.lastFetchedTicker = null;
    },
  },
  extraReducers: (builder) => {
    builder

      /* -------------------------
         FETCH START
      -------------------------- */
      .addCase(fetchEdgarFilingsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      /* -------------------------
         FETCH SUCCESS (REAL OR CACHED)
      -------------------------- */
      .addCase(fetchEdgarFilingsData.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;

        // Guarded assignments (idempotent)
        if (action.payload?.company_info) {
          state.companyInfo = action.payload.company_info;
        }

        if (Array.isArray(action.payload?.filings)) {
          state.filings = action.payload.filings;
        }

        // Only update when a valid ticker exists
        if (typeof action.meta?.arg === "string") {
          state.lastFetchedTicker = action.meta.arg;
        }
      })

      /* -------------------------
         FETCH FAILURE (REAL ONLY)
      -------------------------- */
      .addCase(fetchEdgarFilingsData.rejected, (state, action) => {
        state.loading = false;

        // Explicitly ignore benign rejections
        if (action.payload === "invalid-ticker") {
          state.error = "Invalid ticker symbol.";
          return;
        }

        // Default error
        state.error = action.payload || "Failed to fetch EDGAR data.";
      });
  },
});

export const { clearEdgarData } = edgarSlice.actions;
export default edgarSlice.reducer;
